
























































































import Vue from "vue";

import iwStreet from "@/optimizedEncoding/components/contactInformation/components/Street.vue";
import iwNumber from "@/encoding/pages/questions/contactinformations/Number.vue";
import iwBox from "@/encoding/pages/questions/contactinformations/Box.vue";
import iwPostalCode from "@/encoding/pages/questions/contactinformations/PostalCode.vue";
import iwLocality from "@/encoding/pages/questions/contactinformations/Locality.vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";
import iwCustomerLanguage from "@/encoding/pages/questions/contactinformations/CustomerLanguage.vue";
import iwCompanyName from "@/optimizedEncoding/components/contactInformation/components/CompanyName.vue";
import iwVatNumber from "@/optimizedEncoding/components/contactInformation/components/VatNumber.vue";
import iwCountry from "@/optimizedEncoding/components/contactInformation/components/Country.vue";


import { mapActions, mapGetters } from "vuex";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwStreet: iwStreet,
        iwNumber: iwNumber,
        iwBox: iwBox,
        iwPostalCode: iwPostalCode,
        iwLocality: iwLocality,
        iwCompanyName: iwCompanyName,
        iwVatNumber: iwVatNumber,
        iwAccordion: iwAccordion,
        iwInputRadioGroup: iwInputRadioGroup,
        iwCustomerLanguage: iwCustomerLanguage,
        iwCountry: iwCountry,
    },

    data: function() {
        return {
            isInvoiceFieldsDisplay: false as boolean,
            pathInStoreCustomerName: "customer.name",
            pathInStoreCustomerVatNumber: "customer.vatNumber",
            editModeRadioValue: false as boolean
        };
    },

    computed: {
        ...mapState("CustomersModule", ["customerFormError"]),
        ...mapGetters({
            customerApiErrors: "CustomersModule/customerApiErrors",
        }),

        vatError: function(): string | null {

            // Look for a VAT format error coming from the API.
            const hasVatFormatError = (error: { params: { format: string }; message: string }): boolean => error.params.format == "vat-number";
            const vatFormatError = this.customerApiErrors?.find(hasVatFormatError)?.message ?? null;

            if (vatFormatError) {
                return this.$t("vat_number_invalid") as string;
            }

            // Fall back on other errors (or no errors).
            return (this.customerFormError?.vatNumber as string) ?? null;
        },
        hasInvoicingEnabled: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("customer.hasInvoicingEnabled") || false;
        },
        addressInBelgium: function(): boolean {
            if(this.$store.getters["FormModule/getValueUI"]("customer.location.address.provided.country")
                && this.$store.getters["FormModule/getValueUI"]("customer.location.address.provided.country") !== "BE") {
                this.toggleInvoiceFieldAccordion(false);
                return false;
            }
            return true;
        },
        isEditMode: function(): boolean {
            const customerToEdit = this.$store.getters["FormModule/getValueUI"]("customer.customerToEdit");
            if (customerToEdit) {
                return true;
            }
            return false;
        },
        // IO-224: once a customer has paid, country / VAT / invoicing / company name become
        // non-editable (the backend rejects such changes; see IO-222). hasPayment lives on the
        // fetched customer object (customerToEdit), not on the rebuilt FormModule UI customer.
        isBillingLocked: function(): boolean {
            const customerToEdit = this.$store.getters["FormModule/getValueUI"]("customer.customerToEdit");
            return customerToEdit?.hasPayment === true;
        },
        completeAddress: function(): string | null {
            const customerToEdit = this.$store.getters["FormModule/getValueUI"]("customer.customerToEdit");
            if (customerToEdit) {
                const street = customerToEdit.location?.address?.provided?.street || "";
                if (!street) {
                    return "";
                }
                return street.split(",")[0].trim();
            }
            return "";
        },
        defaultRadioValue: function(): boolean {
            return this.isEditMode ? this.editModeRadioValue : this.hasInvoicingEnabled;
        }
    },
    created: function() {
        if (!this.isEditMode) {
            this.resetFormValues();
        } else {
            const customerToEdit = this.$store.getters["FormModule/getValueUI"]("customer.customerToEdit");
            const providedAddress = customerToEdit.location?.address?.provided || {};
            const streetParts = (providedAddress.street || "")
                .split(",")
                .map((part: string) => part.trim());
            const streetNumber = providedAddress.streetNumber || streetParts[1] || "";
            const box = providedAddress.box || streetParts[2] || "";
            const locality = providedAddress.locality;
            const postalCode = providedAddress.postalCode;
            this.editModeRadioValue = customerToEdit.hasInvoicingEnabled;
            
            if (customerToEdit.hasInvoicingEnabled) {
                this.isInvoiceFieldsDisplay = true;
                this.$store.commit("FormModule/addValueUI", {path: "customer.vatNumber", value: customerToEdit.vatNumber});
                this.$store.commit("FormModule/addValueUI", {path: "customer.name", value: customerToEdit.name});
            } else {
                this.isInvoiceFieldsDisplay = false;
                this.deleteValueUIPath(this.pathInStoreCustomerName);
                this.deleteValueUIPath(this.pathInStoreCustomerVatNumber);
            }

            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.streetNumber", value: streetNumber});
            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.box", value: box});
            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.locality", value: locality});
            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.postalCode", value: postalCode});
            // IO-224: hydrate the real country so the (disabled) country select shows it, the Street
            // autocomplete restricts to it, and saving never overwrites it with the "BE" default.
            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.country", value: providedAddress.country});
            this.$store.commit("CustomersModule/resetCustomerFormError");
        }
    },
    mounted: function() {
        // Set default hasInvoicingEnabled value if not set
        if (this.$store.getters["FormModule/getValueUI"]("customer.hasInvoicingEnabled") === null) {
            this.$store.commit("FormModule/addValueUI", {path: "customer.hasInvoicingEnabled", value: false});
        }
    },

    methods: {
        ...mapActions({
            deleteValueUIPath: "FormModule/deleteValueUIPath"
        }),
        
        resetFormValues: function(): void {
            // Reset all customer form fields
            const fieldsToReset = [
                "customer.location.address.provided.street",
                "customer.location.address.provided.streetNumber",
                "customer.location.address.provided.box",
                "customer.location.address.provided.postalCode",
                "customer.location.address.provided.locality",
                "customer.location.address.provided.country",
                "customer.name",
                "customer.vatNumber",
                "customer.hasInvoicingEnabled",
                "customer.language"
            ];

            fieldsToReset.forEach(field => {
                this.deleteValueUIPath(field);
            });

            this.$store.commit("CustomersModule/resetCustomerFormError");
            this.isInvoiceFieldsDisplay = false;
        },

        toggleInvoiceFieldAccordion: function(value: boolean): void {
            if (value) {
                this.$store.commit("FormModule/addValueUI", {path: "customer.hasInvoicingEnabled", value: true});
                this.isInvoiceFieldsDisplay = true;
            } else {
                this.isInvoiceFieldsDisplay = false;
                this.deleteValueUIPath(this.pathInStoreCustomerName);
                this.deleteValueUIPath(this.pathInStoreCustomerVatNumber);
                this.$store.commit("FormModule/addValueUI", {path: "customer.hasInvoicingEnabled", value: false});
            }
        },
    }
});

